import React from 'react';
import classNames from 'classnames';
import useButtonCallbacks from '../../model/hooks/useButtonCallbacks';
import useItemData from '../../model/hooks/useItemData';
import ItemButtons from '../ItemButtons/ItemButtons';
import ItemSender from '../ItemSender/ItemSender';
import ItemTitle from '../ItemTitle/ItemTitle';
import ItemImages from '../ItemImages/ItemImages';

export default function Item({ customState, ...restProps }) {
  const itemData = useItemData(restProps);
  const fullData = { ...restProps, ...itemData };

  const { onWish } = useButtonCallbacks(fullData);

  return (
    <div
      ref={(ref) => (itemData.domElementsRef.current.item = ref)}
      className={classNames('my-gift__filter-box', `my-gift__filter-box_${customState}`)}
      onClick={onWish}
    >
      <div className={classNames('my-gift__filter-content')}>
        <ItemImages {...fullData} />
        <div className={'my-gift__filter-footer'}>
          <ItemTitle {...fullData} />
          <ItemButtons {...fullData} />
          <ItemSender {...fullData} />
        </div>
      </div>
    </div>
  );
}
